import { mockProfile } from './mock';

export interface Identity {
  /** Full display name (first + last), falling back to the mock nickname. */
  name: string;
  /** "@username", or '' when the Telegram account has no username. */
  handle: string;
  /** Telegram profile photo URL, when available. */
  photo?: string;
  /** First letter of the name, for the avatar placeholder. */
  initial: string;
}

/** The signed-in Telegram user's identity (name / @username / photo), read from
 *  `initDataUnsafe.user`. Static for the session, so no reactivity is needed.
 *  Outside Telegram it falls back to the mock profile. */
export function getIdentity(): Identity {
  const u = window.Telegram?.WebApp?.initDataUnsafe?.user;
  const name = [u?.first_name, u?.last_name].filter(Boolean).join(' ') || mockProfile.nickname;
  return {
    name,
    handle: u?.username ? `@${u.username}` : '',
    photo: u?.photo_url,
    initial: (name.trim()[0] ?? 'A').toUpperCase(),
  };
}
